module.exports = __webpack_public_path__ + "cb789d8bd37b00dae4226948f8436934.svg";